import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import ApiHelper from 'api-helper';

@Module({ name: 'lpAnalytics', namespaced: true })
export default class LpAnalytics extends VuexModule {
  public list: any[] = [];
  public isLoading: boolean = false;

  @Mutation
  public SET_LIST(data: any[]) {
    this.list = data;
  }

  @Mutation
  public updateLoading(val: boolean) {
    this.isLoading = val;
  }

  @Action({ rawError: true })
  public async fetchList(params: any) {
    this.context.commit('updateLoading', true);
    try {
      const res = await ApiHelper.getApi('LpAnalyticsApi').getList(params);
      this.context.commit('SET_LIST', res.data || res);
    } finally {
      this.context.commit('updateLoading', false);
    }
  }
}
